import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';

//import { upload } from './file-upload.fake.service'; // fake service
import { upload } from './file-upload.service';   // real service
import { wait } from './utils';

const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

function getBase64(file) {
  // Returns a promise which gets resolved or rejected based on the reader events
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    // Sets up even listeners BEFORE you call reader.readAsDataURL
    reader.onload = async () => {
      const response = await {
        'fileName': file.name,
        'base64': reader.result,
      };
      // Resolve the promise with the response value
      return resolve(response);

      //const result = reader.result
      //return resolve(result);
    };

    reader.onerror = function (error) {
      return reject(error);
    };
    // Calls reader function
    reader.readAsDataURL(file);
  })
}



export default {
  name: 'uploadFiles',
  components: {

  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    }
  },
  props: {
    elementId: {
      type: Number,
      required: true
    },
    entitySubId: {
      type: Number,
      required: true
    },
  },
  data: function () {
    return {
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'photos',
      iconBase64: null,
      images: [],
    }
  },
  mounted() {
    this.reset();
  },
  methods: {
    readFileAsync(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onload = () => {
          resolve(reader.result);
        };

        reader.onerror = reject;

        reader.readAsDataURL(file);
      })
    },
    async processFile(file) {
      try {
        let contentBuffer = await this.readFileAsync(file);
        return contentBuffer;
      } catch (err) {
      }
    },
    async save(formData) {
      this.images = [];
      const photos = formData.getAll('photos');
      for (var i = 0; i < photos.length; i++) {
        var img = await this.processFile(photos[i]);
        this.images.push({
          'elementId': this.elementId.toString(),
          'entitySubId': this.entitySubId.toString(),
          'base64': img
        });
      }

      let parameters = this.images;
     
      axios.post('/ConditionAssessment/SaveImages', parameters)
        .then(response => {
          if (response.status == 200) {
            this.$alertMsg(this.$t('common.uploadedSuccessfully'), 2);
            //console.log('ProcessPhotos response', response);

            this.$emit('uploadImage', response.data);
          }
        })
        .catch(error => {
          //this.uploadError = error.response;
          this.currentStatus = STATUS_FAILED;
          this.$alertMsg(error.response.data);
        });
    },

    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    async bbb(fileName, base64) {
      await new Promise((resolve) => setTimeout(resolve, 3000));
    },
    aaa(files) {
      const filePromises = files.map((file) => {
        // Return a promise per file
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = async () => {
            try {
              const response = await this.bbb(
                file.name,
                reader.result
              );
              // Resolve the promise with the response value
              //console.log('response', response);
              resolve(response);
            } catch (err) {
              reject(err);
            }
          };
          reader.onerror = (error) => {
            reject(error);
          };
          reader.readAsDataURL(file);
        });
      });

      const fileInfos = Promise.all(filePromises);

      //console.log('fileInfos', fileInfos);

      return fileInfos;
    },
    readFile(file) {
      return new Promise((resolve, reject) => {
        var fr = new FileReader();
        fr.readAsDataURL(file);
        fr.onload = () => {
          //console.log(fr.result);
          return resolve(fr.result);
          //return fr.result;
        };
        //fr.onerror = reject;
        //fr.readAsText(file.blob);
      });
    },
    async getFile(file) {
      const fileBase64 = await getBase64(file);
      //console.log(fileBase64);
      return fileBase64;
    },
    save2(formData) {
      const photos = formData.getAll('photos');

      new Promise(() => {
        for (var i = 0; i < photos.length; i++) {
          this.pp.push({
            'elementId': '1',
            'entitySubId': '0',
            'base64': this.getFile(photos[i])
          });
          //console.log('inside loop', this.pp);
        }
      });
      
      //console.log(this.pp);
      //console.log('aaa');

      
      //this.aaa(formData.getAll('photos'));
      //return;


      //// upload data to the server
      //this.currentStatus = STATUS_SAVING;
      //const photos = formData.getAll('photos');

      //let parameters = [];

      //for (var i = 0; i < photos.length; i++) {
      //  var reader = new FileReader();
      //  reader.readAsDataURL(photos[i]);
      //  reader.onloadend = () => {
      //    parameters.push({
      //      elementId: '1',
      //      entitySubId: '0',
      //      base64: reader.result.toString()
      //    });
      //  }
      //}


      //console.log('formData.getAll(photos)', formData.getAll('photos'));

      
      //var fileName = '';
      //for (var i = 0; i < photos.length; i++) {
      //  fileName = photos[i].name;
      //  var reader = new FileReader();
      //  reader.readAsDataURL(photos[i]);
      //  reader.onload = () => {
      //    let parameters = new FormData();

      //    parameters.append('elementId', '1');
      //    parameters.append('entitySubId', '0');
      //    parameters.append('base64', reader.result.toString());

      //    axios.post('/ConditionAssessment/ProcessPhoto', parameters)
      //      .then(response => {
      //        if (response.status == 200) {
      //          this.$alertMsg(fileName + ' ' +this.$t('common.uploadedSuccessfully'));
      //          console.log('ProcessPhoto response', response);

      //          this.$emit('uploadImage', response.data.id, fileName);
      //        }
      //      })
      //      .catch(error => {
      //        console.log('error', error);
      //        this.uploadError = error.response;
      //        this.currentStatus = STATUS_FAILED;
      //        //this.$alertMsg(error.response.data);
      //      });
      //  }
      //  reader.onerror = function (error) {
      //    console.log('Error: ', error)
      //  }
      //}

      //this.currentStatus = STATUS_SUCCESS;
      //this.reset();

      //return;

      

      //upload(formData)
      //  .then(wait(1500)) // DEV ONLY: wait for 1.5s 
      //  .then(x => {
      //    this.uploadedFiles = [].concat(x);
      //    this.currentStatus = STATUS_SUCCESS;
      //  })
      //  .catch(err => {
      //    this.uploadError = err.response;
      //    this.currentStatus = STATUS_FAILED;
      //  });
    },
    filesChange(fieldName, fileList) {
      // handle file changes
      const formData = new FormData();

      if (!fileList.length) return;

      // append the files to FormData
      Array
        .from(Array(fileList.length).keys())
        .map(x => {
          formData.append(fieldName, fileList[x], fileList[x].name);
        });

      // save it
      this.save(formData);
    }
  },
}
